import type React from 'react'
import { createContext, type ReactNode, useEffect, useState } from 'react'

type Locales = { [key: string]: string }

export const LanguageContext = createContext<Locales>({})

export const LanguageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [translation, setTranslation] = useState<Locales>({})
  useEffect(() => {
    //ブラウザから言語情報を取得
    const userLanguage = navigator.language || navigator.languages[0]
    const baseLanguage = userLanguage.split('-')[0]
    //言語に応じたJSONを取得
    let localeResponse: Response
    const loadTranslations = async () => {
      try {
        const exists = await checkIfJsonExists(baseLanguage)
        if (exists) {
          localeResponse = await fetch(`/locales_${baseLanguage}.json`)
        } else {
          localeResponse = await fetch('/locales.json')
        }
      } catch (err) {
        localeResponse = await fetch('/locales.json')
      }
      const localeData: Locales = await localeResponse.json()
      setTranslation(localeData)
    }

    async function checkIfJsonExists(baseLanguage: string): Promise<boolean> {
      try {
        const response = await fetch(`/locales_${baseLanguage}.json`)
        if (!response.ok) {
          console.log(`HTTP error! Status: ${response.status}`)
          return false
        }
        await response.json()
        return true
      } catch (error) {
        return false
      }
    }
    loadTranslations()
  }, [])
  return <LanguageContext.Provider value={translation}>{children}</LanguageContext.Provider>
}
